
import customerStoreService from './customer-store-service/index.vue';
import customerConfig from './customer-config/index.vue';

export default [
  {
    name: '线下服务',
    path: '/customer/customer-store-service',
    component: customerStoreService,
  },
  {
    name: '商户配置',
    path: '/customer/customer-config',
    component: customerConfig,
  },
];
